import { useStore } from '@nanostores/react'
import clsx from 'clsx'
import { atom, computed } from 'nanostores'
import { useEffect, useState } from 'react'
import { typo } from 'shared/styles'
import { StackIcon } from 'shared/ui'

import css from './Drop.module.scss'
import { useUploadFile } from './hooks'
import { $shouldShowMultipleFilesError } from './PreviewFiles'
import { cleanReUpload } from './utils'

const $dragCount = atom(0)
const $isDragging = computed($dragCount, Boolean)

export function Drop() {
	const isDragging = useStore($isDragging)
	const [isDraggingOver, setIsDraggingOver] = useState(false)

	const uploadFile = useUploadFile()

	useEffect(() => {
		const unListen = $isDragging.listen(
			isDragging => !isDragging && setIsDraggingOver(false)
		)

		const controller = setUpGlobalListeners()

		return () => {
			controller.abort()
			cleanReUpload()
			$shouldShowMultipleFilesError.set(false)
			unListen()
		}
	}, [])

	return (
		isDragging && (
			<section
				className={clsx(css.zone, isDraggingOver && css.active)}
				onDragEnter={() => setIsDraggingOver(true)}
				onDragLeave={() => setIsDraggingOver(false)}
				onDrop={event => {
					const files = event.dataTransfer.files
					$shouldShowMultipleFilesError.set(files.length > 1)

					if (files.length === 1) {
						const file = files[0]
						uploadFile(file)
					}
				}}
			>
				<StackIcon fill='var(--primary)' icon='file' width={64} />
				<h4 className={typo.largeButton}>
					{isDraggingOver ? 'Drop' : 'Drag'} your files here
				</h4>
			</section>
		)
	)
}

const listeners = {
	dragenter(event) {
		event.preventDefault()
		$dragCount.set($dragCount.get() + 1)
	},
	dragleave(event) {
		event.preventDefault()
		$dragCount.set($dragCount.get() - 1)
	},
	dragover: event => event.preventDefault(),
	drop(event) {
		event.preventDefault()
		$dragCount.set(0)
	}
} satisfies Record<string, (event: Event) => void>

function setUpGlobalListeners() {
	const controller = new AbortController()

	const options = {
		signal: controller.signal
	}

	for (const key in listeners) {
		document.addEventListener(
			key,
			listeners[key as keyof typeof listeners],
			options
		)
	}

	return controller
}
